export default __webpack_public_path__ + "static/media/back_b.84f3a8ef.jpg";